import React from "react";
import { useNttxFooterStyles } from "./NttxFooter.styles";
// import { useTranslation } from "react-i18next";

function Footer() {
  const classes = useNttxFooterStyles();
  // const { t } = useTranslation();
  return (
    <footer className={classes.root}>
      {/* {t("footer.copyright", { year: new Date().getFullYear() })} */}
      &copy;{`Copyright ${new Date().getFullYear()} The Nielsen Company™. All Rights Reserved.`}
    </footer>
  );
}

export default Footer;
